import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import Icon from 'shared/components/icon';
import {flashMessage, errorMessage} from 'shared/actions/notifications';
import useAsyncEffect from 'src/hooks/use-async-effect';
import AdminAccessOrganizationService, {
  AdminAccessOrganization,
} from 'src/services/AdminAccessOrganizationService';
import OrganizationFormFields from './organization-form-fields';

interface RouteParams {
  id: string;
}

const EditAccessOrganization = ({match, history}: RouteComponentProps<RouteParams>) => {
  const dispatch = useDispatch();
  const [organization, setOrganization] = useState<AdminAccessOrganization | null>(null);

  useAsyncEffect(async () => {
    const data = await AdminAccessOrganizationService.show(match.params.id);
    setOrganization(data);
  }, [match.params.id]);

  const onUpdate = async (values: AdminAccessOrganization) => {
    if (!organization?._id) return;

    try {
      const updatedOrganization = await AdminAccessOrganizationService.update(organization._id, {
        access_organization: values,
      });

      setOrganization(updatedOrganization);
      dispatch(flashMessage('Access Organization was successfully updated.'));
    } catch (error) {
      console.error('Update failed:', error);
      dispatch(errorMessage('Failed to update organization'));
    }
  };

  if (!organization) {
    return null;
  }

  return (
    <div className="edit-access-organization">
      <Link to="/admin/tools/access-organizations">
        <Icon iconType="chevron-left" className="chevron-left" /> Back to Access Organizations
      </Link>

      <h2>Edit Access Organization</h2>

      <OrganizationFormFields
        organization={organization}
        onSubmit={onUpdate}
        onCancel={() => history.push('/admin/tools/access-organizations')}
      />
    </div>
  );
};

export default EditAccessOrganization;
